import Section from 'components/base/Section';
import EComVendorProductsTable from 'components/tables/EComVendorProductsTable';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const VendorProducts = () => {
  const navigate = useNavigate();

  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="mb-5">Product List</h2>
          <Button
            variant="primary"
            size="sm"
            onClick={() => navigate('/add-product')}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Add Product
          </Button>
        </div>
        <EComVendorProductsTable />
      </Section>
    </div>
  );
};

export default VendorProducts;
